import OnBoardingContainer from "@/components/OnboardingContainer"
import ForgotPasswordForm from "./components/ForgotPasswordForm"


const ForgotPassword = () => {
  return (
    <OnBoardingContainer>
      <ForgotPasswordForm />
    </OnBoardingContainer>
  )
}

export default ForgotPassword